export const SET_BOPIS_SEARCH_RADIUS = "SET_BOPIS_SEARCH_RADIUS";

export const setBopisSearchRadius = (radius) => ({
  type: SET_BOPIS_SEARCH_RADIUS,
  radius,
});
